import { render, staticRenderFns } from "./OptionalData.vue?vue&type=template&id=429c3ba8&scoped=true&"
import script from "./OptionalData.vue?vue&type=script&lang=js&"
export * from "./OptionalData.vue?vue&type=script&lang=js&"
import style0 from "./missing-data.scss?vue&type=style&index=0&id=429c3ba8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "429c3ba8",
  null
  
)

export default component.exports